export const ALL_LOADS = "ALL_LOADS";
export const ALL_LOAD_STATUS = "ALL_LOAD_STATUS";
export const ALL_INVOICE_STATUS = "ALL_INVOICE_STATUS";
export const ALL_PAY_STATUS = "ALL_PAY_STATUS";
export const ALL_EXPENSE_STATUS = "ALL_EXPENSE_STATUS";
export const ALL_LOAD_TRUCK_STATUS = "ALL_LOAD_TRUCK_STATUS";
export const ALL_LOAD_CHART = "ALL_LOAD_CHART";
export const ALL_LOAD_GROSS = "ALL_LOAD_GROSS";
